import { useReviewTop10Query } from '@/hooks/RQHooks/tour/main/useReviewTop10Query';
import ExperienceProductCarousel from './ExperienceProductCarousel';

export default function ReviewTop10List() {
  const { data, isPending } = useReviewTop10Query();

  return <ExperienceProductCarousel products={data ?? []} />;
}
